import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { UiNotificationService } from './ui-notification.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }

  handleError(error: Error | HttpErrorResponse): void {
    super.handleError(error);

    const uiNotificationService = this.injector.get(UiNotificationService);

    if (error instanceof HttpErrorResponse) {
      this.handleHttpError(error, uiNotificationService);
    } else {
      this.handleClientError(error, uiNotificationService);
    }
  }

  private handleHttpError(
    error: HttpErrorResponse,
    uiNotificationService: UiNotificationService
  ): void {
    if (window && window["env"]["debug"] === 'TRUE') {
      uiNotificationService.handleHttpError(error);
    }
  }

  private handleClientError(
    error: Error,
    uiNotificationService: UiNotificationService
  ): void {
    if (error.stack && error.stack.includes('AkitaEntityNotExistsError.AkitaError')) {
      return;
    }

    if (window && window["env"]["debug"] === 'TRUE') {
      uiNotificationService.handleClientError(error);
    }
  }
}
